import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stripHtmlTags',
  standalone: true
})
export class StripHtmlTagsPipe implements PipeTransform {
  private dom_parser: DOMParser;

  transform(value: string | null | undefined): string {
    if (!value || !value.trim()) return '';

    if (!this.dom_parser) this.dom_parser = new DOMParser();

    return this.dom_parser.parseFromString(value, 'text/html').body.textContent?.trim() || '';
  }
}
